import { useSelector } from 'react-redux'
import { getPurchaseErrors } from '../slice'

const usePurchaseErrors = () => {
    const purchaseErrors = useSelector(getPurchaseErrors)
    return purchaseErrors
}

export default usePurchaseErrors
